import { Button } from '@mui/joy';

const EnhancedButton = ({ 
  variant = 'solid', 
  color = 'primary',
  children, 
  gradient = false,
  ...props 
}) => {
  const getButtonStyles = () => {
    if (gradient && variant === 'solid') {
      return {
        background: color === 'primary' 
          ? 'linear-gradient(45deg, #00A884, #007E33)'
          : 'linear-gradient(45deg, #007E33, #00A884)',
        border: 'none',
        '&:hover': {
          background: color === 'primary'
            ? 'linear-gradient(45deg, #009973, #00682A)'
            : 'linear-gradient(45deg, #00682A, #009973)',
          boxShadow: '0 4px 12px rgba(0, 168, 132, 0.3)',
          transform: 'translateY(-1px)',
        },
        '&:active': {
          transform: 'translateY(1px)',
          boxShadow: '0 2px 6px rgba(0, 168, 132, 0.3)',
        },
        transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
        fontWeight: 600,
      };
    }

    return {
      fontWeight: 500,
      transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
      '&:hover': {
        transform: 'translateY(-1px)',
        boxShadow: 'md',
      },
      '&:active': {
        transform: 'translateY(0px)',
      },
    };
  };

  return (
    <Button
      variant={variant}
      color={color}
      sx={getButtonStyles()}
      {...props}
    >
      {children}
    </Button>
  );
};

export default EnhancedButton;